import Container from './SelectedLayout.container';
import SelectedLayout from './SelectedLayout';

export default Container(SelectedLayout);
